export const FeedTypes = {
  teams: 'F30',
  live: 'F26',
  schedule: 'F1',
  standings: 'F3',
  lineups: 'F9',
  events: 'F13',
};
